import KingdomIcon from "../ReactionTable/kingdomIcon.js";
import ResultInfoText from "../ResultsTable/ResultInfoText.js";
import translateTerpeneType from "../../api/typeTranslator.js";
import { useNavigate } from "react-router-dom";
import { speciesLink, kingdomLink } from "../../functions/taxonomyLinks.js";

function EnzymeBasicInfo({ enzymeData }) {
    const navigate = useNavigate();

    return(
    <div className="enzyme-record-table">
                {/*<div className="enzyme-record-row">
                    <div className="enzyme-record-label">Enzyme:</div>
                    <div className="enzyme-record-divider"></div>
                    <div className="enzyme-record-value">{enzymeData.name}</div>
                </div>*/}
                {enzymeData.uniprot && (
                    <div className="enzyme-record-row">
                        <div className="enzyme-record-label">Uniprot:</div>
                        <div className="enzyme-record-divider"></div>
                        <div className="enzyme-record-value">
                        <ResultInfoText text={enzymeData.uniprot} row={3} fontSize="18px" buttonClass="plane-text-button-no-background" linkText="See in UniProt"
           link={enzymeData.uniprot.startsWith("UPI") ? `https://www.uniprot.org/uniparc/${enzymeData.uniprot}/entry` : `https://www.uniprot.org/uniprotkb/${enzymeData.uniprot}/entry`} />
                        </div>
                    </div>
                )}
                {enzymeData.genbank && (
                    <div className="enzyme-record-row">
                        <div className="enzyme-record-label">Genbank:</div>
                        <div className="enzyme-record-divider"></div>
                        <div className="enzyme-record-value">
                        <ResultInfoText text={enzymeData.genbank} row={4} fontSize="18px" buttonClass="plane-text-button-no-background" linkText="See in Genbank"
           link={`https://www.ncbi.nlm.nih.gov/protein/${enzymeData.genbank}`} />
                        </div>
                    </div>
                )}
                <div className="enzyme-record-row">
                    <div className="enzyme-record-label">Taxonomy:</div>
                    <div className="enzyme-record-divider"></div>
                    <div className="enzyme-record-value">
                        {/* Both halves open the matching taxonomy page (Client/TaxonomyPage.js). */}
                        <ResultInfoText text={enzymeData.species} row={5} fontSize="18px" buttonClass="enzyme-record-link"
           onClick={(species) => navigate(speciesLink(species))} tooltipText={`See everything MARTS holds for ${enzymeData.species}`} />
                        {" · "}
                        <ResultInfoText text={enzymeData.kingdom} row={6} fontSize="18px" buttonClass="enzyme-record-link"
           onClick={(kingdom) => navigate(kingdomLink(kingdom))} tooltipText={`See everything MARTS holds for ${enzymeData.kingdom}`} />
                        <KingdomIcon table={[enzymeData]} row={0} isQuickSearch={true} interactiveSearch={() => {}} backgroundColor="rgb(255,255,255)"
           onKingdomClick={(kingdom) => navigate(kingdomLink(kingdom))} />
                    </div>
                </div>
                <div className="enzyme-record-row">
                    <div className="enzyme-record-label">Amino acid sequence:</div>
                    <div className="enzyme-record-divider"></div>
                    <div className="enzyme-record-value">{enzymeData.aminoacid_sequence.length + " amino acids"}</div>
                </div>
                <div className="enzyme-record-row">
                    <div className="enzyme-record-label">Reaction classes:</div>
                    <div className="enzyme-record-divider"></div>
                    <div className="enzyme-record-value">{[...enzymeData.classes].join(",")}</div>
                </div>
                <div className="enzyme-record-row">
                    <div className="enzyme-record-label">Reaction types:</div>
                    <div className="enzyme-record-divider"></div>
                    <div className="enzyme-record-value">{[...enzymeData.types].map((type) => (translateTerpeneType(type, true))).join(",")}</div>
                </div>
            </div>)
}

export default EnzymeBasicInfo;